<div class="screen-title">Add Work Order</div>

<work-order-edit-form 
    [model]="model | async"
    [users]="users | async | active"
    [isNew]="true"
    (onSave)="saveWorkOrder($event)"
    (onCancel)="cancel()"
></work-order-edit-form>
